// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__LB34h","content":"LayoutSettings_content__1aodS"};